import React, { useContext, useEffect, useState } from 'react'
import {
  Button, Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import { current, unwrapResult } from '@reduxjs/toolkit'
import layout from 'antd/lib/layout'
import { useDispatch, useSelector } from 'react-redux'
import { TableRowSelection } from 'antd/lib/table/interface'
import { useHistory } from 'react-router-dom'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { QuantitiesColumns } from './column'
import {DateRangeType, DateSelect, getDateRange} from '../../compnents/form/DateSelect'

import {
  exportRecipeQuantitiesAsync,
  recipeQuantitiesPageAsync,
} from './medicalOverviewSlice'
import { ThemeContext } from '../../theme/ThemeContext'
import {selectInsuranceArray} from "../../app/applicationSlice";

export const RecipeQuantities = (props: {
  currentTab: string
  registrations: any
}) => {
  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()
  const insuranceArray = useSelector(selectInsuranceArray)

  const theme = useContext(ThemeContext)
  const [head, tail] = getDateRange(DateRangeType.ThisYear)

  const [form] = Form.useForm()

  const [scrollHeight, setScrollHeight] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)
  const [isClassifiedByDiseaseChecked, setIsClassifiedByDiseaseChecked] = useState(false)

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const onResize = () => {
    const table = document.getElementById('tableHeight')
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 20
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  const getData = () => {
    setPageLoading(true)
    dispatch(
      recipeQuantitiesPageAsync({
        ...params,
        timeHead: params?.timeHead || head,
        timeTail: params?.timeTail || tail,
        patientId: props?.registrations?.patientId,
        groupByDisease: isClassifiedByDiseaseChecked ? 1 : 0,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        onResize() // 初始化设置高度
        window.addEventListener('resize', onResize)
        setPage({
          items: res?.records,
          total: res?.total,
        })
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  const outCluedExport = () => {
    setExportLoading(true)
    dispatch(
      exportRecipeQuantitiesAsync({
        ...params,
        patientId: props?.registrations?.patientId,
        groupByDisease: isClassifiedByDiseaseChecked ? 1 : 0,

      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '开方数量汇总.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  useEffect(() => {
    if (props.currentTab == '2') getData()
  }, [params])

  return (
    <>
      <Col
        style={{
          height: 'calc(100% - 30px)',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Form
          form={form}
          onFinish={(values) => {
            if(!values?.timeHead && values?._dateRange == 6){
              return
            }
            setParams({
              ...params,
              ...values,
              current: 1,
            })
          }}
        >
          <Row justify='space-between'>
            <Space>
              <Form.Item name="name" noStyle>
                <Input
                  autoComplete="off"
                  placeholder="商品名称"
                  allowClear
                  style={{ width: "12em", marginRight: "6px" }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='险种类型'
                  style={{ width: '8.25rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={form.submit}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={'ZIFEI'}>自费</Select.Option>
                  {insuranceArray.map((v) => (
                    <Select.Option value={v.insuranceCode} key={v.id}>
                      {v.insuranceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="drugType" noStyle>
                <Select
                  placeholder="类型"
                  allowClear
                  style={{ width: "8em", marginRight: "6px" }}
                  onChange={form.submit}
                >
                  <Select.Option value={0}>药品</Select.Option>
                  <Select.Option value={1}>诊疗</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name='' noStyle>
                <DateSelect
                  placeholder='发生时间'
                  style={{ width: '8rem' }}
                  onChange={() => {
                    form.submit()
                  }}
                  initialValue={DateRangeType.ThisYear}
                  labelPrefix=''
                  namePrefix='time'
                  allowClear={false}
                />
              </Form.Item>
              <Button type='primary' htmlType='submit' loading={pageLoading}>
                查询
              </Button>
            </Space>
            <Space>
              <Checkbox checked={isClassifiedByDiseaseChecked}
                onChange={() => {
                  setIsClassifiedByDiseaseChecked(!isClassifiedByDiseaseChecked)
                  setParams({
                    ...params,
                    groupByDisease: isClassifiedByDiseaseChecked ? 1 : 0,
                  })
                }}>按疾病分类</Checkbox>
              <Button
                type='primary'
                onClick={() => outCluedExport()}
                loading={exportLoading}
              >
                导出
              </Button>
            </Space>
          </Row>
        </Form>
        <Col
          id="tableHeight"
          style={{
            height: '100%',
            backgroundColor: theme.pn,
            borderRadius: 10,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <EditableList
            style={{
              marginTop: '15px',
              width: '100%',
              height: '90%',
              overflow: 'hidden',
            }}
            scroll={{ x: '30rem', y: Number(scrollHeight) }}
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            pageSizeOptions={['10', '20', '50', '100']}
            loading={pageLoading}
            rowKey={(m: any) => m.id}
            columns={QuantitiesColumns(params.size * (params.current - 1),isClassifiedByDiseaseChecked)}
            onChangePage={(current, size) =>
              setParams({ ...params, current, size: size || 10 })
            }
          />
        </Col>
      </Col>
    </>
  )
}
